import QRCode from "qrcode";

export async function renderQrCanvas(
  canvas: HTMLCanvasElement,
  text: string,
  width = 420,
): Promise<void> {
  await QRCode.toCanvas(canvas, text, {
    width,
    margin: 4,
    errorCorrectionLevel: "M",
    color: {
      dark: "#000000",
      light: "#ffffff",
    },
  });
}
